import React from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { history } from "../Root";
import Axios from "axios";
import { API_ROOT } from "./utils/api-config";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};
class DriverStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: true,
    };
    this.toggleActive = this.toggleActive.bind(this);
  }

  toggleActive() {
    this.setState((prevState) => ({
      active: !prevState.active,
    }));
  }
  componentDidMount() {
    this.props.driverStats;
  }
  handleClick = (id) => {
    Axios.get(`${API_ROOT}/deliveries/${id}`, auth).then((response) =>
      history.push(`/fulfillments/${response.data.delivery.order_id}`)
    );
  };
  render() {
    const { driverStats } = this.props;
    const activeDrivers = this.state.active
      ? driverStats.filter((driver) => driver.active == true)
      : driverStats;
    return (
      <div className="container-fluid">
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #cdcecf;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #7dc3ae85;
      color: #2f0246;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    `}
        </style>
        <Navbar className="bg-primary justify-content-between">
          <Navbar.Brand>
            {this.state.active ? "Active Drivers" : "All Drivers"}{" "}
            <Badge variant="light">{activeDrivers.length}</Badge>
          </Navbar.Brand>
          <Button onClick={this.toggleActive} variant="info">
            {this.state.active ? "Show All Drivers" : "Show Active Only"}
          </Button>
          <Link to="/create-driver">
            <Button variant="primary">Create Driver</Button>
          </Link>
        </Navbar>
        <Table className="bg-flat" responsive>
          <thead>
            <tr>
              <th>Driver Name</th>
              <th>Twilio Phone</th>
              <th>Active Conversation Phone</th>
              <th>Active Order</th>
              <th>Deliveries All Time</th>
              <th>Deliveries This Month</th>
              <th>OnTime Deliveries This Month</th>
              <th>Revenue All Time</th>
              <th>Revenue This Month</th>
            </tr>
          </thead>
          <tbody>
            {activeDrivers.map((driv) => (
              <tr key={driv.id}>
                <td>
                  <Link to={`/drivers/${driv.id}`}>
                    {driv.first_name} {driv.last_name}
                  </Link>
                </td>
                <td>{driv.twilio_phone_number || ""}</td>
                <td>{driv.active_conversation_phone_number || ""}</td>
                <td>
                  {" "}
                  {driv.active_delivery_id ? (
                    <Button
                      onClick={() => this.handleClick(driv.active_delivery_id)}
                    >
                      {driv.active_delivery_id || ""}
                    </Button>
                  ) : (
                    ""
                  )}
                </td>
                <td>{driv.allcount || 0}</td>
                <td>{driv.monthcount || 0}</td>
                <td>{driv.monthOTcount || 0}</td>
                <td>
                  {driv.allrevsum
                    ? new Intl.NumberFormat("ca-EN", {
                        style: "currency",
                        currency: "CAD",
                      }).format(driv.allrevsum / 100)
                    : 0}
                </td>
                <td>
                  {driv.revsum
                    ? new Intl.NumberFormat("ca-EN", {
                        style: "currency",
                        currency: "CAD",
                      }).format(driv.revsum / 100)
                    : 0}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(DriverStats);
